import { Controller } from "../../Controller";
import {
    CriarTemplateService,
    DeletarTemplatesService,
    ListarTemplatesService,
    AtualizaTemplateService,
    DeletarDocTemplatesService,
    AlteraStatusTemplateService,
} from "../../../Services/Geral/GestaoDeTemplates/GestaoDeTemplatesService";
import { ITemplate } from "../../../Interfaces/Geral/GestaoDeTemplates/GestaoDeTemplatesInterfaces";
import { IDocumentosTemplate } from "../../../Interfaces/Geral/Documentos/DocumentosInterface";

export function ListarTemplatesController() {
    return Controller(ListarTemplatesService());
}

export function DeletarTemplatesController(
    ID_DOCUMENTO_TEMPLATE_FORMULARIO: number
) {
    return Controller(
        DeletarTemplatesService(ID_DOCUMENTO_TEMPLATE_FORMULARIO)
    );
}

export function CriarTemplateController(requestBody: ITemplate) {
    return Controller(CriarTemplateService(requestBody));
}

export function AtualizaTemplateController(requestBody: IDocumentosTemplate) {
    return Controller(AtualizaTemplateService(requestBody));
}

export function AlteraStatusTemplateController(ID_DOCUMENTO_TEMPLATE: number) {
    return Controller(AlteraStatusTemplateService(ID_DOCUMENTO_TEMPLATE));
}

export function DeletarDocTemplatesController(ID_DOCUMENTO_TEMPLATE: number) {
    return Controller(DeletarDocTemplatesService(ID_DOCUMENTO_TEMPLATE));
}
